import { render, staticRenderFns } from "./ConfirmDialogComponent.vue?vue&type=template&id=45f493f3"
import script from "./ConfirmDialogComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialogComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports